import welfareRequest from './welfareRequest'
import welfareRequestBranch from './welfareRequestBranch'
import WelfareType from './WelfareType'
import WelfareManagerBranch from './WelfareManagerBranch'
import WelfareAccountMoneyManagement from './WelfareAccountMoneyManagement'
import WelfareManagerHR from './WelfareManagerHR'
import WelfareManageQuest from './WelfareManageQuest'

export default {
  welfareRequest,
  welfareRequestBranch,
  WelfareType,
  WelfareManagerBranch, // ผู้จัดการสาขา
  WelfareAccountMoneyManagement, // การเงิน
  WelfareManagerHR, // ผู้จัดการHR
  WelfareManageQuest // แบบสอบถาม
}



// WEBPACK FOOTER //
// ./src/components/HRM/Welfare/index.js